import { type FC } from 'react';

import { useFragment as useApolloFragment } from '@apollo/client/react';
import { Box, Stack } from '@mui/material';

import type { ReportComponentProps } from '@modules/_shared/components/report-editor/ReportEditorContext';
import { STEP_AGENCY_PROFILE_FRAGMENT } from '@modules/reports/cma-reports/cmaReportsQueries';
import StepAgencyProfileSettings from '@modules/reports/cma-reports/step-agent/StepAgencyProfileSettings';
import StepAgencyTeamMembers from '@modules/reports/cma-reports/step-agent/StepAgencyTeamMembers';
import { FooterActionsComponentWithoutForm } from '@modules/reports/shared/FooterActionsComponentWithoutForm';

export const StepAgencyProfile: FC<ReportComponentProps> = props => {
  const { reportId } = props;

  const { data } = useApolloFragment({
    fragment: STEP_AGENCY_PROFILE_FRAGMENT,
    fragmentName: 'StepAgencyProfile',
    from: {
      __typename: 'cma_reports',
      id: reportId,
    },
  });

  return (
    <Stack
      sx={{
        height: '100%',
        justifyContent: 'space-between',
      }}
    >
      <Box sx={{ p: 2 }}>
        <StepAgencyProfileSettings
          includeAgencyDescription={data?.include_agency_description ?? false}
        />
      </Box>
      <StepAgencyTeamMembers reportId={reportId} />
      <FooterActionsComponentWithoutForm updating={false} {...props} />
    </Stack>
  );
};

export default StepAgencyProfile;
